import { t } from 'i18next';
import cn from 'classnames';

import { formatPrice } from '~utils/number';

import { BALANCES } from './constants';
import styles from './styles.module.scss';

export const getGiftCardBalancesComponents = ({ currentBalance, nextBalance, useGiftCard }) => [
  {
    id: BALANCES.CURRENT_BALANCE,
    description: t(`GiftCardBalance:${BALANCES.CURRENT}`),
    amount: formatPrice(currentBalance),
    className: styles.currentBalance
  },
  {
    id: BALANCES.CURRENT_BALANCE,
    description: t(`GiftCardBalance:${BALANCES.NEXT}`),
    amount: formatPrice(nextBalance),
    className: cn(styles.nextBalance, {
      [styles.hiddenNextBalance]: !useGiftCard
    })
  }
];

export const getNextBalance = (currentBalance, total) => Math.max(0, currentBalance - total);
